import { RViewsHttp } from '@rhybus/api'

import { apiPath, fetchProvider } from './api'

/**mpfRViewsHttp:
 * A simple async operator for views.
 */

export const mpfRViewsHttp = () => {
  try {
    return new RViewsHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint RViewsHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)    
    throw error
  }
}

